import React, { useState } from "react";

const MenuList = ({
  options = [],
  label,
  name,
  value,
  onChange,
  required = false,
  disabled = false,
  error,
  idKey = "id",
  displayKey = "name",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = (selectedValue) => {
    onChange({
      target: {
        name,
        value: selectedValue,
      },
    });
    setIsOpen(false);
  };

  const selectedOption = options.find((opt) => opt[idKey] === value);
  const displayValue = selectedOption
    ? selectedOption[displayKey]
    : "Select an option";

  return (
    <div className="mb-6">
      {label && (
        <label className="mb-2 block text-sm font-medium text-gray-700">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative">
        <button
          type="button"
          className={`block w-full rounded-md border ${
            error ? "border-red-500" : "border-gray-300"
          } px-3 py-2 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 ${
            disabled ? "cursor-not-allowed bg-gray-100" : "bg-white"
          }`}
          onClick={toggleDropdown}
          disabled={disabled}
        >
          <div className="flex items-center justify-between">
            <span className="truncate">{displayValue}</span>
            <svg
              className={`h-5 w-5 text-gray-400 transition-transform ${
                isOpen ? "rotate-180" : ""
              }`}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </div>
        </button>

        {isOpen && (
          <div className="absolute z-10 mt-1 w-full rounded-md bg-white shadow-lg">
            <ul className="ring-black max-h-60 overflow-auto rounded-md py-1 text-base ring-1 ring-opacity-5 focus:outline-none">
              {options.map((option) => (
                <li
                  key={option[idKey]}
                  className={`relative cursor-default select-none py-2 pl-3 pr-9 hover:bg-indigo-600 hover:text-white ${
                    value === option[idKey]
                      ? "bg-indigo-600 text-white"
                      : "text-gray-900"
                  }`}
                  onClick={() => handleSelect(option[idKey])}
                >
                  <div className="flex items-center">
                    <span
                      className={`ml-3 block truncate ${
                        value === option[idKey]
                          ? "font-semibold"
                          : "font-normal"
                      }`}
                    >
                      {option[displayKey]}
                    </span>
                  </div>
                  {value === option[idKey] && (
                    <span className="absolute inset-y-0 right-0 flex items-center pr-4">
                      <svg
                        className="h-5 w-5"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};

export default MenuList;